import {
  type Thought,
  type MeiliSuggestedThought,
  type MeiliOrigin,
  type Origin,
} from "@/generated/fastapi";

export function turnMeiliSuggestedThoughtsToThoughts(
  thoughts: Thought[],
): MeiliSuggestedThought[] {
  return thoughts.map((thought) => ({
    objectID: thought.id,
    user_id: thought.user_id,
    mindstring: thought.mindstring,
    situation_id: thought.situation_id,
    prototype: thought.prototype,
    language: thought.language,
    latest_at: thought.latest_at,
    origin_id: thought.origin_id,
  }));
}

export function turnOriginsToMeiliOrigins(origins: Origin[]): MeiliOrigin[] {
  return origins.map((origin) => ({
    objectID: origin.id,
    user_id: origin.user_id,
    raw_text_input: origin.raw_text_input,
    processed_status: origin.processed_at ? "PROCESSED" : "UNPROCESSED",
    latest_at: origin.latest_at,
    user_note: origin.user_note,
    language: origin.language,
  }));
}
